var angular = require('angular');
var _module = require('./index');

require('../core/utils');
require('../events');


_module.requires.push(
    'listreports.core',
    'listreports.events'
);

_module.controller('ContactFormCtrl',[
    '$scope',
    '$rootScope',
    '$utils',
    '$location',
    '$http',
    '$events',

    function ContactFormCtrl($scope, $rootScope, $utils, $location, $http, $events){
        var API_URL =  "https://www.listreports.com";
        $scope.forms = {};
        $scope.contactForm = {
            model: {
                name:'',
                emailAddress:'',
                mobileNumber:'',
                requestsQualification: false,
                hasAgent: false,
                agentName: '',
                helpOption:'',
                feedback:''
            }
        };

        $scope.submitContactForm = function(e){
            if($scope.forms.contactForm.$invalid) return;
            $events.track('Lead Form Submit', {
                Source: $scope.eventSource
            });
            $rootScope.showFullscreenLoader();
            var data = {
                name: $scope.contactForm.model.name,
                email: $scope.contactForm.model.emailAddress,
                phone: $scope.contactForm.model.mobileNumber,
                property_url: $location.absUrl(),
                report_id: $scope.reportId,
                type: $scope.type,
                source: $scope.source,
                requests_qualification: $scope.contactForm.model.requestsQualification,
                has_agent: $scope.contactForm.model.hasAgent,
                agent_name: $scope.contactForm.model.agentName,
                feedback: $scope.contactForm.model.feedback,
            };
            
            $http.post(API_URL + '/v1/vendor/lead', data)
            .success(function() {
                $rootScope.hideFullscreenLoader();
                $scope.showThankYouMessage = true;
            })
            .error(function(err) {
                $rootScope.hideFullscreenLoader();

                console.log('Get Financed Error', err);

                alert('There was a problem submitting the form. If this problem persists please contact us at support@listreports.com');
            });
        }; 

        $scope.$watch('selectedHelpOption', function() {
            $scope.contactForm.model.helpOption = $scope.selectedHelpOption;
        });

        function getFeedback(){
            var isOption = $scope.options[$scope.options.length - 1].name !== $scope.contactForm.model.helpOption;
            if(isOption){
                return $scope.contactForm.model.helpOption;
            }
            return !$scope.contactForm.model.optionalHelp ? $scope.contactForm.model.helpOption : $scope.contactForm.model.optionalHelp;
        }
    }]
);

_module.directive('contactForm', [
    '$utils',
    '$location',
    '$http',
    '$events',
    
    function($utils, $location, $http, $events) {
        return {
            restrict: 'E',
            replace: true,
            controller: 'ContactFormCtrl',
            templateUrl: 'js/components/modals/templates/contact-form.tmpl.html',
            scope: {
                title:'@',
                thankYouMessage:'@',
                type:'@',
                source:'@',
                eventSource:'@',
                options:'=',
                reportId:'@',
                reportOwner: '=',
                counterpart: '=',
                selectedHelpOption: '='
            }
        };
    }]
);